import { combineReducers } from "redux"
import User from "redux/ducks/User"

const rootReducer = combineReducers({
  user: User,
})

export default rootReducer



// WEBPACK FOOTER //
// ./src/redux/configureRootReducer.js